<template>
    <select :id="uid"
            :class="classList"
            :tabindex="tabindex"
            :multiple="multiple"
            :readonly="readonly"
            :disabled="disabled">
        <slot></slot>
    </select>
</template>

<script>
    export default {
        name: "select2",
        // props: ['options', 'value', 'multiple', 'classList', 'placeholder'],

        props: {
            options: Array,
            value: null,
            multiple: {
                type: Boolean,
                default: false
            },
            required: {
                type: Boolean,
                default: false
            },
            readonly: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            classList: Array,
            placeholder: String,
            dropdownParent: {
                type: String,
                default: ""
            },
            tabindex: {
                type: Number,
                default: -1
            },
            emptyOption: {
                type: Boolean,
                default: false
            },
            allowClear: null
        },

        data () {
            return {
                uid: _.uniqueId('comp-select')
            }
        },


        mounted () {
            this.initSelect2()
        },

        methods: {
            initSelect2 () {
                let vm = this,
                    allowClear = this.allowClear ? this.allowClear : this.emptyOption,
                    prerequisites = {
                        data: this.parsedOptions,
                        placeholder: this.placeholder,
                        multiple: this.multiple,
                        readonly: this.readonly,
                        disabled: this.disabled,
                        allowClear: allowClear
                    }

                if (!_.isEmpty(this.dropdownParent))
                    prerequisites = _.assign(prerequisites, {
                        dropdownParent: $(this.dropdownParent)
                    })

                $(this.$el)
                    // init select2
                    .select2(
                    prerequisites
                    )
                    // emit event on change.
                    .on('change', function (event) {
                        const values = $(this).val()
                        vm.$emit('input', values)
                    })
                    /*                    .on('select2:close', function(evt) { // important part
                                            var $target     = $(evt.target)
                                            var $formGroup  = $target.data('select2').$container.parents('.form-group')
                                            debugger
                                        })*/
                    .val(this.value)
                    .trigger('change')

                if (this.tabindex !== -1)
                    $(`#select2-${this.uid}-container`, this.$el).prop('tabindex', this.tabindex)
            },

            parseOptions (options, emptyOption) {
                var res = _.map(
                    options,
                    (opt) => ({
                        id: opt.id,
                        text: opt.text ?
                            opt.text :
                            opt.name ?
                                opt.name :
                                ''
                    })
                )
                if (this.emptyOption)
                  res.push({id:-1, text:"Aucun"})
                return res
            }
        },

        computed: {
            parsedOptions () {
                return this.parseOptions(this.options)
            }
        },

        watch: {
            value (value, oldValue) {
                //                debugger
                console.info(" [Select2]: received a new value\n", "new value =", value, "oldValue =", oldValue)
                //                const arrayUnchanged = _.isEmpty(_.difference(value, oldValue))
                // update value
                if (!_.isNil(value))
                    $(this.$el).val(value)
            },
            options (options, oldOptions) {
                // update options
                if (!_.isEqual(options, oldOptions)) {
                    console.info(" [Select2]: received new options:", "new options =", options, "old options =", oldOptions)
                    $(this.$el).select2({
                        placeholder: this.placeholder,
                        data: this.parseOptions(options),
                        multiple: this.multiple,
                        allowClear: this.allowClear ? this.allowClear : this.emptyOption
                    }).val(this.value).trigger('change')
                }
            }
        },

        beforeDestroy () {
            // console.log('before')
            $(this.$el).off().select2('destroy')
        }

    }
</script>



// WEBPACK FOOTER //
// client/components/Form/Select2.vue